import { constantRoutes } from '@/router';
import Layout from '@/layout';

const state = {
    routes: [],
    addRoutes: [],
};

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes;
        state.routes = constantRoutes.concat(routes);
    },
};

const actions = {
    generateRoutes({ commit }, router) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-require-imports, no-undef
            router = require('../../assets/asd.json');
            const loadMenuData = [];
            Object.assign(loadMenuData, router);
            const asyncRoutes = [];
            generaMenu(asyncRoutes, loadMenuData);
            let accessedRoutes = [];
            accessedRoutes = asyncRoutes || [];
            commit('SET_ROUTES', accessedRoutes);
            resolve(accessedRoutes);
        });
    },
};
function generaMenu(asyncRoutes, router) {
    router.forEach((item) => {
        const menu = {
            path: item.path ? item.path : '',
            // eslint-disable-next-line @typescript-eslint/no-require-imports, no-undef
            component: item.component === 'Layout' ? Layout : (resolve) => require([`@/views${item.component}`], resolve),
            name: item.name,
            redirect: item.redirect ? item.redirect : '',
            children: [],
            meta: {
                title: item.meta.title,
                isSingle: item.meta.isSingle,
                icon: item.meta.icon ? item.meta.icon : '',
                breadcrumb: item.meta.breadcrumb,
                activeMenu: item.meta.activeMenu ? item.meta.activeMenu : '',
                keepAlive: item.meta.keepAlive ? item.meta.keepAlive : false,
                isUseCache: item.meta.isUseCache ? item.meta.isUseCache : false,
            },
            hidden: item.hidden,
        };
        if (item.children) {
            generaMenu(menu.children, item.children);
        }
        asyncRoutes.push(menu);
    });
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/permission.js